import { z } from 'zod';

import {
    Insurance,
    IntervalType,
    PreferredAvailability,
    Priority,
    SeriesPlanningMode,
} from '@/models/appointment/Appointment.ts';
import { PVSProvider } from '@/models/customers/PVSProvider.ts';

// This is an easy way to prevent too long description and info field. If exceeded we should provide a better solution.
const INFO_FIELD_MAX_LENGTH = 1000 * 1000;
const DESCRIPTION_FIELD_MAX_LENGTH = 1000 * 1000;

export const book_appointment_form_schema = z.object({
    pvs_provider: z.enum(PVSProvider),
    practice_doc_cirrus_id: z.string().optional(),
    insurance: z.enum(Insurance),
    apt_type_id_or_schedule_type_pvs_id: z.string().min(1),
    calendar_pvs_id: z.string().min(1),
    duration: z.number().positive(),
    date_time: z.iso.datetime(),
    priority: z.enum(Priority),
    description: z.string().max(DESCRIPTION_FIELD_MAX_LENGTH).optional(),
    info: z.string().max(INFO_FIELD_MAX_LENGTH).optional(),
    is_offered: z.literal(true),
}); // TODO: add refine here and make practice id required if pvs_provider is doc_cirrus

export const collection_configuration_schema = z.object({
    start_date: z.string(), // YYYY-MM-DD
    interval_type: z.enum(IntervalType),
    interval_frequency: z.number().min(1),
    preferred_availability: z.enum(PreferredAvailability),
    preferred_time: z.string().optional(), // HH:mm when preferred_availability is FIXED
    number_of_appointments: z.number().min(2),
    planning_mode: z.enum(SeriesPlanningMode).optional(),
});

export type CollectionConfigFormValues = z.infer<typeof collection_configuration_schema>;
